import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proficiency-table',
  templateUrl: './proficiency-table.component.html',
  styleUrls: ['./proficiency-table.component.css']
})
export class ProficiencyTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/ericzayas/Documents/relativePitch/src/app/components/proficiency-table/proficiency-table.component.ts